/**
 * Pre-launch: hide the left tool rail and use a minimal top bar (logo + account).
 * Flip to `true` after launch to restore sidebar navigation.
 */
export const PEEQD_LEFT_RAIL_ENABLED = false;
